<div class="rpc-icon-field" title="{{title | translate}}">
    <rpc-icon class="rpc-icon-field-icon" [iconName]="iconName"></rpc-icon>
    <div class="rpc-icon-field-text">
        {{ value }}
    </div>
</div>